module.exports = __webpack_public_path__ + "static/media/fig_1_BC.c3013c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_1_BC.jpg
// module id = 652
// module chunks = 0